import type { MessageValue } from 'contexts/intl/intlContext';
import type { NextWorkflowError } from 'models/NextWorkflowError';
import type { HttpClientError, HttpError } from 'utils/http/httpClient.model';
import { isHttpTimeoutError } from 'utils/http/httpClient.model';

export function toApiError(error: HttpClientError): ApiError {
  return isHttpTimeoutError(error)
    ? {
        message: error.timeOutErrorMessage,
        values: {
          timeInMillis: error.timeout,
        },
      }
    : {
        message: error.message,
        workflowErrors: parseWorkflowErrors(error),
      };
}

export function parseWorkflowErrors(error: HttpError): NextWorkflowError[] | undefined {
  const rejections = (error?.payload as any)?.rejections;
  return Array.isArray(rejections) && rejections.length > 0 ? rejections : undefined;
}

export interface ApiError {
  message: string;
  values?: Record<string, MessageValue>;
  workflowErrors?: NextWorkflowError[];
}

export interface ApiFunctionalError {
  message?: string;
}

export interface ApiErrorMessage {
  message: string;
  values?: Record<string, MessageValue>;
  newVersion?: number;
  status?: number;
  correlationId?: string;
  functionalErrorType?: 'rfq-version-mismatch';
}
